/** @jsxImportSource @emotion/react */

import IconButton from "@mui/material/IconButton";
import anime from "animejs";
import useIsMobile from "../../../hooks/device/useIsMobile";
import R from "../../../R";
import { useGuidedMode } from "../../hooks/useGuidedMode";
import { CircleQuestionMark } from "../BonusXIcons/CircleQuestionMark";

const getGuidedModeSwitchByStep = (stepname: string) => {
  return document.getElementById(`guided-mode-switch-${stepname}`);
};

const scrollToGuidedMode = (stepname: string): void => {
  const target = getGuidedModeSwitchByStep(stepname);
  if (!target) return;

  const { top } = target.getBoundingClientRect();
  window.scrollTo({ top, behavior: "smooth" });
};

function highlightsGuidedModeContainer(isMobile: boolean) {
  anime({
    targets: "#guided-mode-container",
    translateY: [0, 15, 0],
    duration: 1300,
    delay: isMobile ? 400 : 0,
  });
}

function HeaderGuidedMode(): JSX.Element {
  const isMobile = useIsMobile();
  const { hasGuidedMode, showGuidedMode, guidedModeEnabled, activeStepName } = useGuidedMode();

  return (
    <IconButton
      size="large"
      disabled={!hasGuidedMode}
      onClick={() => {
        showGuidedMode(true);
        setTimeout(() => scrollToGuidedMode(activeStepName), guidedModeEnabled ? 350 : 10);

        if (guidedModeEnabled) {
          highlightsGuidedModeContainer(isMobile);
        }
      }}
    >
      <CircleQuestionMark height={16} width={16} color={hasGuidedMode ? R.colors.vividBlue : R.colors.disabledGray} />
    </IconButton>
  );
}

export default HeaderGuidedMode;
